<template>
    <a-modal :get-container="modalContainer" v-model="visibles" :maskClosable="false" :title="modalTitle"  :confirmLoading="loading" centered class="modal-box"
        @ok="handlerSubmit"
        @cancel="handleCancel">
        <a-spin :spinning="loading">
            <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-form-item :hidden="true">
                    <a-input v-decorator="['layout_id']" />
                </a-form-item>
                <a-form-item :hidden="true">
                    <a-input v-decorator="['user_id']" />
                </a-form-item>
                <a-form-item class="mb10" label="姓名">
                    <a-input placeholder="请输入姓名" autocomplete="off" v-decorator="['name', { rules: [{ required: true, message: '请输入姓名'}] }]" />
                </a-form-item>
                <a-form-item class="mb10" label="手机号">
                    <a-input placeholder="请输入手机号" v-decorator="['mobile', { rules: [{ required: true, message: '请输入手机号' },{pattern: new RegExp(/^1[\d]{10}$/),message: '手机号格式不正确'}],trigger:'blur' }]" />
                </a-form-item>
                <a-form-item class="mb10" label="性别">
                    <a-radio-group v-decorator="['sex']">
                        <a-radio value="男"> 男 </a-radio>
                        <a-radio value="女"> 女 </a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item class="mb10" label="邮箱">
                    <a-input placeholder="请输入邮箱" autocomplete="off" v-decorator="['email']" />
                </a-form-item>
                <a-form-item class="mb10" label="单位">
                    <a-input placeholder="请输入单位" autocomplete="off" v-decorator="['company']" />
                </a-form-item>
                <a-form-item class="mb10" label="备注">
                    <a-textarea placeholder="请输入备注" autocomplete="off" v-decorator="['remark']" />
                </a-form-item>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script>
const fields = ['user_id','name','sex', 'mobile', 'email','company','remark','layout_id'];
import pick from 'lodash.pick'
import moment from "moment";
import { mapState } from 'vuex';
export default {
    name: "createUpdatePerson",
    data() {
        return {
            modalContainer:() => document.body,
            modalTitle : '',
            loading:false,
            visibles: false,
            labelCol: {xs: {span: 24},sm: {span: 5},},
            wrapperCol: {xs: {span: 24},sm: {span: 19},},
            form: this.$form.createForm(this),
        };
    },

    components: {},

    computed: {
         ...mapState(['notSeatPersonList']),
    },

    methods: {
         show(item,modalContainer,params) {
            this.visibles = true;
            modalContainer && (this.modalContainer = () => modalContainer);
            // 动态设置参数
            this.form.setFieldsValue(params);
            // 数据回显
            if(item){
                let copyItem = JSON.parse(JSON.stringify(item));
                this.form.setFieldsValue(pick(copyItem, fields))
            }
            this.modalTitle = item ? '编辑用户' : '添加用户'
        },

        handlerSubmit(){
            this.form.validateFields((errors, values) => {
                if (!errors) {
                    this.loading = true;
                    this.$request.post({ url: "createUpdateUser",data:values }).then(person => {
                        this.$message.success('操作成功');
                        // 获取未分配人员列表(更新对应的数据)
                        person = person.data;
                        let index = this.notSeatPersonList.findItem({id:person.id},false);
                        // 新增
                        if(index == -1){
                            this.notSeatPersonList.unshift(person)
                        // 更新
                        }else{
                            this.notSeatPersonList.splice(index,1,person);
                        }
                        this.$emit('ok',person);
                        this.$store.commit('updateState',{notSeatPersonList:this.notSeatPersonList});
                        this.visibles = false;
                    }).finally(() => {
                        this.loading = false;
                    })
                }
            })
        },
        handleCancel(){
            this.form.resetFields() // 清理表单数据（可不做）
        }
    },
    created() {
        // 防止表单未注册
        fields.forEach(v => this.form.getFieldDecorator(v))
    },
    mounted() {
        
    },
}

</script>
